module.exports = __webpack_public_path__ + "static/media/gpv-news.fd536e3e.jpg";